/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceControls {
    getFixupPrototypeFunction() { return ComplianceControls.fixupPrototype; }

    static newInstance(model: Partial<ComplianceControls>): ComplianceControls {
        let obj = Object.assign(new ComplianceControls(), model);
        ComplianceControls.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceControls>): ComplianceControls {
        if (!model) return null;
        return ComplianceControls.newInstance(<ComplianceControls> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceControls) {
        if (!obj) return;

        models.ComplianceControls.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceControls): boolean {
        Object.setPrototypeOf(obj, ComplianceControls.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_controls === undefined) {
            this.total_controls = 0;
        }
        if (this.automated_controls === undefined) {
            this.automated_controls = 0;
        }
        if (this.assessed_controls === undefined) {
            this.assessed_controls = 0;
        }
        if (this.success === undefined) {
            this.success = 0;
        }
        if (this.violations === undefined) {
            this.violations = 0;
        }
        if (this.errors === undefined) {
            this.errors = 0;
        }
    }

    month: string;

    /**
     * Total number of controls
     */
    total_controls: number;

    /**
     * Total number of automated controls
     */
    automated_controls: number;

    /**
     * Total number of assessed controls
     */
    assessed_controls: number;

    /**
     * Total number of compliance controls
     */
    success: number;

    /**
     * Total number of non-compliance controls
     */
    violations: number;

    /**
     * Total number of controls with error
     */
    errors: number;

}
